module.exports = __webpack_public_path__ + "img/logo-company_4.da2d3f48.png";